// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"26":"f577b8fa","349":"6acc37e7","455":"e05b7145","474":"ac4d4de0","483":"ea05cb7e","575":"6ae39085","741":"b9768df1","795":"7303f417","985":"71e9eb96","996":"472d4cd8"}[chunkId] + ".js";
};